import { useEffect } from 'react';
import { getText } from 'i18n/intl';
import { setSelectedPeriod } from 'slices/availabilityCollectionPeriod.slice';
import {
  fetchAvailabilityCollectionTimeslots,
  setSelectedTimeslot,
} from 'slices/availabilityCollectionTimeslot.slice';
import { useAppDispatch } from 'slices/store';
import { Collapse, Tabs } from '@timeedit/ui-components/antd';
import PeriodDrawer from './Periods/PeriodDrawer';
import Periods from './Periods/Periods';
import ReservationMapping from './ReservationMapping';
import TimeslotDrawer from './Timeslots/TimeslotDrawer';
import Timeslots from './Timeslots/Timeslots';

const AvailabilityCollectionSettings = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchAvailabilityCollectionTimeslots());
  }, [dispatch]);

  const onChange = () => {
    // Reset selected timeslot and period when switching tabs
    dispatch(setSelectedTimeslot(null));
    dispatch(setSelectedPeriod(null));
  };

  return (
    <div style={{ width: '100%' }}>
      <Collapse defaultActiveKey={['1']} ghost style={{ fontSize: 18 }}>
        <Collapse.Panel
          header={getText('availability_collection.reservation_mapping.title')}
          key="1"
        >
          <ReservationMapping />
        </Collapse.Panel>
      </Collapse>
      <Tabs
        onChange={onChange}
        defaultActiveKey="1"
        style={{ marginTop: 20 }}
        items={[
          {
            label: getText('availability_collection.period.title'),
            key: '1',
            children: <Periods />,
          },
          {
            label: getText('availability_collection.timeslot.title'),
            key: '2',
            children: <Timeslots />,
          },
        ]}
      />
      <TimeslotDrawer />
      <PeriodDrawer />
    </div>
  );
};

export default AvailabilityCollectionSettings;
